import { useEffect, useState } from 'react';
import { fetchKalenterinTuotteet } from '@/services/kalenteriService';

export function useCalendarItems(id) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (id == null) {
      return;
    }

    let ignore = false;
    setLoading(true);

    (async () => {
      try {
        const res = await fetchKalenterinTuotteet(id);

        if (!ignore) setData(res);
      }
      catch (e) {
        if (!ignore) setError(e);
      }
      finally {
        if (!ignore) setLoading(false);
      }
    })();

    return () => {
      ignore = true;
    };
  }, [id]);

  return { data, loading, error };
};
